import { omit } from 'lodash';
import type { AuthSystemInfo, AuthUserData, RootState } from '../types';
import type { AuthStoreLike } from '../actions/backendAuth';

const EMPTY_SYSTEM_INFO: AuthSystemInfo = {};
const EMPTY_USER_DATA: AuthUserData = {};

const EMPTY_AUTH_STATE = {
    token: null,
    refreshToken: null,
    authWithPassword: false,
    userData: EMPTY_USER_DATA,
    systemInfo: null
};

export function getBackendAuthState(state: RootState) {
    return state.backend?.auth || EMPTY_AUTH_STATE;
}

export function getAuthStore(state: RootState): AuthStoreLike {
    return getBackendAuthState(state);
}

export function getAuthToken(state: RootState) {
    return getBackendAuthState(state).token;
}

export function getRefreshToken(state: RootState) {
    return getBackendAuthState(state).refreshToken;
}

export function isAuthWithPasswordEnabled(state: RootState) {
    return Boolean(getBackendAuthState(state).authWithPassword);
}

export function getSystemInfo(state: RootState) {
    return getBackendAuthState(state).systemInfo || EMPTY_SYSTEM_INFO;
}

export function getSafeSystemInfo(state: RootState) {
    return omit(getSystemInfo(state), ['companySecretToken', 'toJSON']);
}

export function getAuthUserData(state: RootState) {
    return getBackendAuthState(state).userData || EMPTY_USER_DATA;
}

export function getAuthRole(state: RootState) {
    return getAuthUserData(state).role ?? null;
}

export function getAuthTeamId(state: RootState) {
    const teamId = getAuthUserData(state).teamId;
    return typeof teamId === 'number' ? teamId : null;
}

export function getAuthUserId(state: RootState) {
    return getAuthUserData(state).userId ?? null;
}

export function isVodafoneUser(state: RootState) {
    return getAuthRole(state) === 'vf_agent';
}
